export default __webpack_public_path__ + "static/media/cube.3e51cb45.svg";